const FranceFlagIcon = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5923_27096)">
        <path
          d="M21.7143 0.5H2.28571C1.02335 0.5 0 1.51482 0 2.76667V15.2333C0 16.4852 1.02335 17.5 2.28571 17.5H21.7143C22.9767 17.5 24 16.4852 24 15.2333V2.76667C24 1.51482 22.9767 0.5 21.7143 0.5Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 0.5H24V17.5H16V0.5Z"
          fill="#ce1126"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0.5H8V17.5H0V0.5Z"
          fill="#002654"
        />
      </g>
      <defs>
        <clipPath id="clip0_5923_27096">
          <rect y="0.5" width="24" height="17" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FranceFlagIcon;
